import { useCallback, useRef, useState } from 'react';
import { useToast } from '../components/UIProvider';

/**
 * A Download PDF button's busy state. `download(make)` runs `make`, the async function that saves
 * the PDF, one at a time, and says so when it fails. Making a long report's PDF takes a few seconds,
 * so the button says what it is doing meanwhile.
 */
export default function usePdfDownload() {
  const showToast = useToast();
  const [busy, setBusy] = useState(false);
  const running = useRef(false);
  const download = useCallback(async (make) => {
    if (running.current) return;
    running.current = true;
    setBusy(true);
    try {
      await make();
    } catch (err) {
      if (typeof console !== 'undefined') console.error('PDF download failed', err);
      showToast('error', 'Could not make the PDF. Please try again.');
    } finally {
      running.current = false;
      setBusy(false);
    }
  }, [showToast]);
  return [busy, download];
}
